import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel, debugPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel - this also fires PageView automatically
    initMetaPixel();
    // Debug after a short delay to check status
    setTimeout(() => {
      debugPixel();
    }, 2000);
  }, []);
  return <LandingPage data-id="element-0" />;
}